import {SafeHtml} from '@angular/platform-browser';
import {AcquisitionType, BenefitType, Period, ShippingType, UnitType,} from '../helpers/constants';
import {FixedBenefitDocument} from './fixed-benefit-document';
import {BenefitPaymentType, County} from "../helpers/enums";

export class FlexibleBenefit {
  id: number;
  name?: string;
  description?: string;
  pictureUrl?: string;
  benefitTypeId: BenefitType;
  unitType: UnitType;
  shippingType: ShippingType;
  acquisitionType: AcquisitionType;
  status?: string;
  price: number;
  expirationDate: string;
  categoryId: number;
  providerId?: number;
  providerPictureUrl?: string;
  categoryName?: string;
  providerName?: string;
  location?: string;
  locations?: Array<County>;
  period?: Period;
  shippingTypeLabel?: string;
  benefitTypeLabel?: string;
  parsedExpirationDate?: string;
  quantity?: number;
  benefitPeriod?: number;
  createdOn?: string;
  sku?: string;
  beneficiaryAcceptedFlag?: boolean;
  benefitDocuments: Array<FixedBenefitDocument>;
  benefitTaxCategory?: number;
  isDeleted?: boolean;
  serviceFee?: number;
  vatPercentage?: number;
  isBusinessProduct?: any;
  responseTransport24Pay?: any;
  processorCode?: string;
  includesVat: boolean;
  cardPaymentAllowed?: boolean;
  dynamicAttributesHtml?: string;
  dynamicAttributesSafeHtml?: SafeHtml;
  discountPercentage: number;
  isOffer: boolean;
  benefitPaymentType: BenefitPaymentType;

  hasCreditCardAllowed(): boolean {
    return this.benefitPaymentType === BenefitPaymentType.BudgetAndCreditCard || this.benefitPaymentType === BenefitPaymentType.CreditCard;
  }

  hasSalaryPaymentAllowed(): boolean {
    return this.benefitPaymentType === BenefitPaymentType.BudgetAndSalary || this.benefitPaymentType === BenefitPaymentType.Salary;
  }

  isSalaryPaymentOnly(): boolean {
    return this.benefitPaymentType === BenefitPaymentType.Salary;
  }
}
